module.exports = __webpack_public_path__ + "static/media/coffin.7a426661.svg";